<div class="d-flex justify-content-between align-items-center mb-3">
  <h1 class="fs-5 fw-bold mb-0">Behaviour Config</h1>
</div>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body">
    @for (siteConfigRule of siteConfigRules; track siteConfigRule) {
      <div class="card card-body border-0 shadow mb-3">
        <app-site-config-element [siteConfigRule]="siteConfigRule" [readonly]="true" [disabled]="!canUpdate()">
        </app-site-config-element>
      </div>
    }
  </div>
</div>
